
import { Component, namespace, Vue } from 'bits/vue'
import type { SearchResultDataCollectionMap } from 'bits/web_search'
import { SearchFilters } from 'bits/web_search'
import OzTextButton, { OzTextButtonColorScheme } from 'library/v4/components/OzTextButton.vue'
import { keyBy } from 'lodash-es'

@Component({
  components: {
    OzTextButton,
  },
})
export default class ContentPickerSearchModes extends Vue {
  OzTextButtonColorScheme = OzTextButtonColorScheme

  $refs!: {
    imagesButton: OzTextButton
    gifButton: OzTextButton
    youtubeButton: OzTextButton
    spotifyButton: OzTextButton
    webButton: OzTextButton
    indicatorBar: HTMLDivElement
    indicator: HTMLDivElement
  }

  buttons = [
    { filter: SearchFilters.Images, ref: 'imagesButton', text: this.__('Images') },
    { filter: SearchFilters.Gif, ref: 'gifButton', text: this.__('GIF') },
    { filter: SearchFilters.Videos, ref: 'youtubeButton', text: this.__('YouTube') },
    { filter: SearchFilters.Audio, ref: 'spotifyButton', text: this.__('Spotify') },
    { filter: SearchFilters.Web, ref: 'webButton', text: this.__('Web') },
  ]

  @namespace('browser').Getter isPhone!: boolean
  @namespace('contentPicker').Action openSearch!: () => void
  @namespace('contentPicker').Action pickSearchFilter!: (payload: { filter: SearchFilters }) => void
  @namespace('contentPicker').Getter searchFilter!: SearchFilters
  @namespace('contentPicker').Getter searchQuery!: string
  @namespace('contentPicker').Getter currentSearchResultsMap!: SearchResultDataCollectionMap
  @namespace('contentPicker').Action search!: (payload?: { query?: string; url?: string }) => void

  isShook = false
  SearchFilters = SearchFilters

  shake(): void {
    this.isShook = false
    setTimeout(() => {
      this.isShook = true
    }, 1)
  }

  pickFilter(filter: SearchFilters): void {
    this.openSearch()
    this.pickSearchFilter({ filter: filter })
    this.repositionIndicator()
    if (!this.searchQuery || this.searchQuery.trim() == '') {
      this.$emit('pick-without-search', filter)
      return
    }
    // Search immediately after clicking the filter
    // if the results are not populated yet.
    if (
      !this.currentSearchResultsMap ||
      !this.currentSearchResultsMap[this.searchFilter] ||
      this.currentSearchResultsMap[this.searchFilter].length == 0
    ) {
      this.search()
    }
  }

  get refNamesMap(): Record<string, { ref: string }> {
    return keyBy(this.buttons, 'filter')
  }

  get highlightedElement(): HTMLElement | null {
    const refName = this.refNamesMap[this.searchFilter]?.ref
    const ref = this.$refs[refName][0]
    return ref?.$el
  }

  repositionIndicator(): void {
    if (!this.highlightedElement) return
    const indicatorElement = this.$refs.indicator
    indicatorElement.style.width = this.highlightedElement.offsetWidth + 'px'
    indicatorElement.style.left = this.highlightedElement.offsetLeft - this.$refs.indicatorBar.offsetLeft + 'px'
  }

  mounted(): void {
    this.repositionIndicator()
  }
}
